import React, { useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";
import HttpClientXml from "../../../utils/HttpClientXml";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
};

function AddCity() {
    const [cityName, setCityName] = useState("");
    const [image, setImage] = useState(null);
    const navigate = useNavigate();
    
    const handleImageUpload = async (e) => {
        const data = new FormData();
        data.append("image", e.target.files[0]);
        try {
            const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
            if (res?.image) {
                setImage(res.image);
                toast.success("Image uploaded successfully!");
            }
        } catch (error) {
            toast.error("Failed to upload image.");
            console.error("Error uploading image:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            name: cityName,
            image: image,
        };
        try {
            const res = await HomeService.addCity(data);
            if (res?.status) {
                toast.success("City added successfully!");
                clearAddForm();
                navigate("/manage-city");
            }
        } catch (error) {
            toast.error("Failed to add city.");
            console.error("Error adding city:", error);
        }
    };

    const clearAddForm = () => {
        setCityName("");
        setImage(null);
    };

    return (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
            <div className="container-fluid">

                <div className="mt-5">
                <div style={headLineStyle}  className="page-headline">
                        Add City
                    </div>
                    {/* <hr /> */}

                    <section
                     className="chartBox_area"
                     >
                      
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6 mt-3">
                                    <label htmlFor="name">
                                        City Name<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        className="form-control"
                                        value={cityName}
                                        onChange={(e) => setCityName(e.target.value)}
                                        placeholder="Enter City Name"
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mt-3">
                                    <label htmlFor="cityImage">
                                        Upload City Image<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="file"
                                        id="cityImage"
                                        className="form-control"
                                        onChange={handleImageUpload}
                                        accept="image/*"
                                        required
                                    />
                                </div>
                                {image && (
                                    <div className="col-md-6 mt-3">
                                        <label>Preview:</label>
                                        <img
                                            src={image}
                                            alt="City Preview"
                                            width="100"
                                            style={{ display: "block", marginTop: "10px" }}
                                        />
                                    </div>
                                )}
                            </div>
                            <button
                                type="submit"
                                className="btn mt-3"
                                style={{
                                    background:'rgb(133, 218, 79)',
                                    borderRadius:'13px'
                                }}
                            >
                                Add City
                            </button>
                        </form>





                        {/* <div className="add_city_div_wrapper">
                            <form onSubmit={handleSubmit} className="add_city_form">
                                <div className="upload_image_div_wrapper" style={{
                                    position:'relative',
                                    zIndex:'9'
                                }}>
                                <input
                                        type="file"
                                        id="cityImage"
                                        className="form-control"
                                        onChange={handleImageUpload}
                                        accept="image/*"
                                        required
                                        style={{
position:'absolute',
top:'0',
left:'0',
width:'100%',
height:'150px',
opacity:'0',
zIndex:'9999'
                                        }}
                                    />
                                <i class="fa-solid fa-arrow-up-from-bracket"></i>
                                <p>Upload City Image</p>
                                </div>
                               <div className="preview_image_wrapper">
                                    <img src={image}/>
                                </div>
                                <div>
                                    <label htmlFor="name" style={{
                                        fontSize: "16px",
                                        fontWeight: 500,
                                        color:'white'
                                    }}>
                                        City Name<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        className=" city_input"
                                        value={cityName}
                                        onChange={(e) => setCityName(e.target.value)}
                                        placeholder="Enter City Name"
                                        required
                                        style={{
                                            background:'transparent',
                                            display:'block',
                                            color:'white',
                                            fontSize:'16px',
                                            padding:'8px 10px',
                                          
                                            width:'100%'

                                        }}
                                    />
                                </div>
                                <button
                                type="submit"
                                className="btn mt-3"
                                style={{
                                    background:'rgb(133, 218, 79)',
                                    borderRadius:'13px'
                                }}
                            >
                                Add City
                            </button>
                            </form>
                        </div> */}
                    </section>
                </div>
            </div>
        </div>
    );
}

export default AddCity;
